import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { apiRequest } from "../authconfig";

export const acquireApiAccessToken = async (instance) => {
    const account = instance.getActiveAccount() || instance.getAllAccounts()[0];

    if (!account) {
        throw new Error("An authenticated account is required to call the API.");
    }

    const request = { ...apiRequest, account };
    try {
        const response = await instance.acquireTokenSilent(request);
        return response.accessToken;
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
            const redirectRequest = error.claims ? { ...request, claims: error.claims } : request;
            await instance.acquireTokenRedirect(redirectRequest);
        }
        throw error;
    }
};
